module.exports = __webpack_public_path__ + "static/media/email.961cd27c.svg";